import type { State } from '../store/types';
import { getContactsAsUsers, getEmployeesAsUsers } from '../store/selectors';

export function getUsersForAccess(state: State) {
  return [
    ...getEmployeesAsUsers(state).map((u) => ({
      name: u.name,
      uuid: u.uuid,
      email: u.email ?? '',
      accessLevel: u.accessLevel?.toString() ?? 'NONE',
      accessExpires: '',
    })),
    ...getContactsAsUsers(state).map((u) => ({
      name: u.name,
      uuid: u.uuid,
      email: u.email ?? '',
      accessLevel: u.accessLevel?.toString() ?? 'NONE',
      partnerName: u.partnerName,
      partnerUuid: u.partnerUuid,
      accessExpires: u.accessExpires ?? '',
    })),
  ];
}
